function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_REQUEST = "GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_REQUEST";
export var GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_SUCCESS = "GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_SUCCESS";
export var GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_FAILURE = "GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_FAILURE";
export var RESET_GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC = "RESET_GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC";

// Fetches aiUsers by email containing value from Front API.
// Relies on Redux Thunk middleware.
export var fetchAiUsersByEnabledAtNotNullOrderByGroupMembersCountDesc = function fetchAiUsersByEnabledAtNotNullOrderByGroupMembersCountDesc(page, size) {
  var queryString = urlSearchParams({
    page: page,
    size: size,
    projection: "public"
  });
  return _defineProperty({}, CALL_API, {
    types: [GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_REQUEST, GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_SUCCESS, GET_AIUSERSBYENABLEDATNOTNULLORDERBYGROUPMEMBERSCOUNTDESC_FAILURE],
    endpoint: "aiUsers/search/findByEnabledAtNotNullOrderByGroupMembersCountDesc".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};
export var GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING_REQUEST = "GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING_REQUEST";
export var GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING_SUCCESS = "GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING_SUCCESS";
export var GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING_FAILURE = "GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING_FAILURE";
export var RESET_GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING = "RESET_GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING";

// Fetches aiUsers by email containing value from Front API.
// Relies on Redux Thunk middleware.
export var fetchAiUsersByEnabledAtNotNullAndUsernameContaining = function fetchAiUsersByEnabledAtNotNullAndUsernameContaining(page, size, username) {
  var queryString = urlSearchParams({
    page: page,
    size: size,
    projection: "public",
    username: username
  });
  return _defineProperty({}, CALL_API, {
    types: [GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING_REQUEST, GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING_SUCCESS, GET_AIUSERSBYENABLEDATNOTNULLANDNAMECONTAINING_FAILURE],
    endpoint: "aiUsers/search/findByEnabledAtNotNullAndUsernameContaining".concat(queryString),
    init: {
      credentials: "same-origin"
    }
  });
};
export var POST_AIUSERQUESTION_REQUEST = "POST_AIUSERQUESTION_REQUEST";
export var POST_AIUSERQUESTION_SUCCESS = "POST_AIUSERQUESTION_SUCCESS";
export var POST_AIUSERQUESTION_FAILURE = "POST_AIUSERQUESTION_FAILURE";
export var RESET_POST_AIUSERQUESTION = "RESET_POST_AIUSERQUESTION";
export var postAiUserQuestion = function postAiUserQuestion(aiUser, question) {
  return _defineProperty({
    aiUser: aiUser,
    question: question
  }, CALL_API, {
    types: [POST_AIUSERQUESTION_REQUEST, POST_AIUSERQUESTION_SUCCESS, POST_AIUSERQUESTION_FAILURE],
    endpoint: "aiUsers/".concat(aiUser.id, "/questions/with-reply"),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(question),
      credentials: "same-origin"
    }
  });
};
export var resetPostAiUserQuestion = function resetPostAiUserQuestion() {
  return function (dispatch, getState) {
    return dispatch({
      type: RESET_POST_AIUSERQUESTION
    });
  };
};
export var POST_AIUSERINVESTMENTPLAN_REQUEST = "POST_AIUSERINVESTMENTPLAN_REQUEST";
export var POST_AIUSERINVESTMENTPLAN_SUCCESS = "POST_AIUSERINVESTMENTPLAN_SUCCESS";
export var POST_AIUSERINVESTMENTPLAN_FAILURE = "POST_AIUSERINVESTMENTPLAN_FAILURE";
export var RESET_POST_AIUSERINVESTMENTPLAN = "RESET_POST_AIUSERINVESTMENTPLAN";
export var postAiUserInvestmentPlan = function postAiUserInvestmentPlan(aiUser, investmentPlan) {
  return _defineProperty({
    aiUser: aiUser,
    investmentPlan: investmentPlan
  }, CALL_API, {
    types: [POST_AIUSERINVESTMENTPLAN_REQUEST, POST_AIUSERINVESTMENTPLAN_SUCCESS, POST_AIUSERINVESTMENTPLAN_FAILURE],
    endpoint: "aiUsers/".concat(aiUser.id, "/investmentPlans/with-rationale"),
    init: {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(investmentPlan),
      credentials: "same-origin"
    }
  });
};
export var resetPostAiUserInvestmentPlan = function resetPostAiUserInvestmentPlan() {
  return function (dispatch, getState) {
    return dispatch({
      type: RESET_POST_AIUSERINVESTMENTPLAN
    });
  };
};